export default {
  CREATE_GIFT_CHAIRS_SUCCESS: 'CREATE_GIFT_CHAIRS_SUCCESS',
  CREATE_GIFT_CHAIRS_LOADING: 'CREATE_GIFT_CHAIRS_LOADING',
  CREATE_GIFT_CHAIRS_REJECT: 'CREATE_GIFT_CHAIRS_REJECT',
  CREATE_GIFT_CHAIRS_FAILED: 'CREATE_GIFT_CHAIRS_FAILED',
}